//keep these in sync with ICartValidationError
export const MISSING_ADDRESS_ID = 'missing_address_id';
export const MISSING_DELIVERY_DATE = 'missing_delivery_date';
export const INVALID_PAYMENT_METHOD = 'invalid_payment_method';
export const TIME_SLOT_EXPIRED = 'time_slot_expired';



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/constants/checkout-errors.js